import { render } from "./player-video.vue?vue&type=template&id=9c9f2e70&scoped=true"
import script from "./player-video.vue?vue&type=script&lang=js"
export * from "./player-video.vue?vue&type=script&lang=js"

import "./player-video.vue?vue&type=style&index=0&id=9c9f2e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9f2e70"]])

export default __exports__